// internal-deps
import { PAYMENT_CODES } from "@swiggy-private/payment-core";

// interfaces
import {
    MorePaymentOptionsProps,
    PaymentOptionProps,
    PaymentGroupDataDef,
    PaymentGroupData,
    PaymentGroupMeta,
    PaymentMethod,
    PaymentMethodMeta,
} from "@payment-ui/interfaces";

// helpers
import { getIconCloudinaryUrl as getCloudinaryUrl } from "./Icon";
import { getPaymentGroupDisableMessage } from "./Payment";
import { Option, Some } from "@swiggy-private/js-fp";

export const getPaymentOptions = <T extends PaymentGroupDataDef>(data: MorePaymentOptionsProps<T>): T[] => {
    return data.paymentGroups ?? [];
};

export const getPaymentOptionSectionTitle = <T extends PaymentGroupDataDef>(
    data: MorePaymentOptionsProps<T>,
): string | undefined => data.title;

export const getPaymentOptionIconUrl = <T extends PaymentGroupDataDef>(data: T): string =>
    data.meta?.iconUrl != null ? getCloudinaryUrl(data.meta.iconUrl) : "";

export const getPaymentOptionGroupDisplayName = (paymentData: PaymentGroupDataDef): string => {
    return paymentData.displayName;
};

export const getPaymentOptionGroupName = (paymentData: PaymentGroupDataDef): string => {
    return paymentData.groupName.toUpperCase();
};

export function getPaymentMethodFromGroup(
    group: PaymentGroupData<PaymentGroupMeta, PaymentMethod<PaymentMethodMeta>>,
    methodName: string,
): Option<PaymentMethod<PaymentMethodMeta>> {
    return Some(
        group.paymentMethods.find((paymentMethod) => paymentMethod.name.toLowerCase() === methodName.toLowerCase()),
    );
}

export const getPaymentOptionTooltipText = (paymentData: PaymentGroupDataDef): string => {
    const aPayMethod = getPaymentMethodFromGroup(paymentData, PAYMENT_CODES.AMAZONPAY);
    if (aPayMethod.isSome()) {
        return aPayMethod.unwrap()?.meta?.apayDelinkGroupMessage ?? "";
    }
    return "";
};

export const getPaymentOptionSubtext = <T extends PaymentGroupDataDef>(groupData: T): string | undefined => {
    return groupData.meta?.ctaSubtext ?? "";
};

export const getPaymentOptionAlertMessage = (props: PaymentOptionProps<PaymentGroupDataDef>): string => {
    const disableMessage = getPaymentGroupDisableMessage(props.groupData);

    return disableMessage.length > 0 ? disableMessage : "";
};
